import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 90vh;

  body {
    font-family: Poppins;
  }

`;

export const Title = styled.h1``;
